import { defineComponent as _defineComponent } from 'vue'
import BCXQuickLayer from '@/components/molecules/BCXQuickLayer.vue';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXMobileFullscreenDesktopLayer',
  props: {
  isOpen: Boolean
},
  setup(__props) {



const {
  isMobileLayout
} = useResponsiveness();

return { __sfc: true,isMobileLayout, BCXQuickLayer }
}

})